export default "__VITE_ASSET__CubtRhzS__"